import "./chatmessages.scss";
import { useEffect, useRef, useState } from "react";
import { useChatDatabase } from "../../lib/chatDatabase";
import { useUserDatabase } from "../../lib/userDatabase";
import { useAudioRecorder } from "../chatmessages/hooks/useAudioRecorder"; 
import { useAttachments } from "../chatmessages/hooks/useAttachments";
import { useSendMessage } from "../chatmessages/hooks/useSendMessage";
import ChatHeader from "./components/ChatHeader";
import MessageItem from "./components/MessageItem";
import ChatInput from "./components/ChatInput";
import AttachmentPreview from "./components/AttachmentPreview";

const Chatmessages = () => {
    const [text, setText] = useState("");
    const endRef = useRef();
    const { currentUser } = useUserDatabase();
    const { currentReceiver, isCurrentUserBlocked, isReceiverBlocked, messages, sendMessage } = useChatDatabase();
    
    const { 
        attachments, 
        handleFileSelect, 
        removeAttachment, 
        addAudioAttachment, 
        clearAttachments 
    } = useAttachments();

    const { isRecording, toggleRecording } = useAudioRecorder({
        onRecordingComplete: addAudioAttachment, 
        onError: () => alert("Microphone not accessible!")
    });

    const { isSending, cooldown, handleSend } = useSendMessage({
        sendMessage,
        clearAttachments,
        setText
    });

    useEffect(() => {
        endRef.current?.scrollIntoView({ behavior: "auto" });
    }, [messages]);

    const isBaseDisabled = isCurrentUserBlocked || isReceiverBlocked;
    const isInputDisabled = isBaseDisabled || isSending || cooldown > 0;

    return (
        <div className="chatmessages">
            <ChatHeader receiver={currentReceiver} />

            <div className="center">
                {messages?.map((message, index) => (
                    <MessageItem 
                        key={message._id || `temp-msg-${index}`} 
                        message={message}
                        isOwner={message.senderId === currentUser?.id}
                        currentReceiver={currentReceiver}
                    />
                ))}
                <div ref={endRef}></div>
            </div>

            <div className="bottom">
                <AttachmentPreview 
                    attachments={attachments} 
                    onRemove={removeAttachment} 
                />

                <ChatInput 
                    text={text}
                    setText={setText}
                    isDisabled={isInputDisabled} 
                    isSending={isSending}        
                    cooldown={cooldown}  
                    onSend={() => handleSend(text, currentReceiver, attachments)}
                    onFileSelect={handleFileSelect}
                    isRecording={isRecording}
                    toggleRecording={toggleRecording}
                />
            </div>
        </div>
    );
};

export default Chatmessages;